import React from 'react';

import Avatar from '~/components/Avatar';
import { FixedDetail } from '~/components/Details/FixedDetails';
import { getStatusImageAndLabel } from '~/components/Details/getStatus';
import { IProcessesInstance } from '~/store/modules/processes/types';

// TODO(Cabral): Atualizar a interface IProcessesInstance
const listFixedDetails = (data?: IProcessesInstance): Array<FixedDetail> => {
  return [
    {
      label: 'Status do processo',
      value: getStatusImageAndLabel(data?.state ?? undefined).name,
      icon: (
        <img
          src={getStatusImageAndLabel(data?.state ?? undefined).image}
          alt="status-processo"
        />
      ),
    },
    {
      label: 'Data de criação',
      value: data?.startTime
        ? !data?.superProcessInstanceId
          ? new Date(data?.startTime).toLocaleDateString('pt-br', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: 'numeric',
              timeZone: 'utc',
              minute: 'numeric',
            })
          : new Date(data?.startTime).toLocaleDateString('pt-br', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: 'numeric',
              minute: 'numeric',
            })
        : 'Sem data',
    },
    {
      label:
        data?.state === 'EXTERNALLY_TERMINATED' ||
        data?.state === 'INTERNALLY_TERMINATED'
          ? 'Data de cancelamento'
          : 'Data de conclusão',
      value: data?.endTime
        ? new Date(data?.endTime).toLocaleDateString('pt-br', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            timeZone: 'utc',
            hour: 'numeric',
            minute: 'numeric',
          })
        : 'Aguardando conclusão',
    },
    {
      label: 'Versão do processo',
      value: data?.versionTag ?? '-',
    },
    {
      label: 'Registrado por',
      value: data?.registradoPor ?? 'Sem responsável',
      icon: <Avatar name={data?.registradoPor} size={16} />,
    },
    {
      label: 'Cancelado por',
      value: (data as any)?.canceladoPor ?? 'Sem responsável',
      icon: <Avatar name={(data as any)?.canceladoPor} size={16} />,
      renderCondition:
        data?.state === 'EXTERNALLY_TERMINATED' ||
        data?.state === 'INTERNALLY_TERMINATED',
    },
    {
      label: 'Motivo do cancelamento',
      value:
        (data as any)?.wedo_justificativaDoCancelamento ??
        'Processo cancelado por suas execuções',
      renderCondition:
        data?.state === 'EXTERNALLY_TERMINATED' ||
        data?.state === 'INTERNALLY_TERMINATED',
    },
  ];
};

export default listFixedDetails;
